export default "__VITE_ASSET__BhxX4SJ2__"